import { render, staticRenderFns } from "./df-accordion.vue?vue&type=template&id=1fd1869d&"
import script from "./df-accordion.ts?vue&type=script&lang=js&"
export * from "./df-accordion.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports